<template>
  <div>
    <div>{{ item.mtcItemName }}</div>
    <div class="p-d-flex p-jc-between p-p-4">
      <div
        @click="changeStatus(1)"
        class="status"
        :class="{ active: item.checkResult == 1 }"
      >
        <i class="icon pi pi-eye-slash"></i>
        <span>{{ __("Unchecked") }}</span>
      </div>
      <div
        @click="changeStatus(2)"
        class="status"
        :class="{ active: item.checkResult == 2 }"
      >
        <i class="icon pi pi-check"></i>
        <span>{{ __("valid") }}</span>
      </div>
      <div
        @click="changeStatus(3)"
        class="status"
        :class="{ active: item.checkResult == 3 }"
      >
        <i class="icon pi pi-times"></i>
        <span>{{ __("Invalid") }}</span>
      </div>
    </div>
    <p-transition-expand>
      <div v-if="item.showResultPanel && item.checkResult != 1">
        <div>
          <span>{{ __("Comments") }}</span>
          <p-vue-textarea
            :autoResize="true"
            rows="4"
            class="p-inputtext--alt"
            v-model="itemLocal.remarks"
            @blur="checkRemarkChanged"
          />
        </div>
        <div class="p-d-flex p-jc-between">
          <p-vue-button
            class="button p-button-rounded p-button-success p-mt-2"
            :label="__('Add Photo')"
            @click="addImage"
          />
          <p-vue-button
            v-if="item.checkResult == 3"
            class="button p-button-rounded p-button-success p-mt-2"
            :label="__('Create a service call')"
            @click="addServiceCall"
          />
        </div>
        <div class="images p-mt-4">
          <local-image
            v-for="(image, index) of item.Images"
            :key="index"
            :image="image"
            :allImages="item.Images"
            :newImageID="newImageID"
            :newImage="newImage"
          ></local-image>
        </div>
      </div>
    </p-transition-expand>
    <i-override-dialog
      v-model:visible="showModal"
      :style="{
        width: '100%',
        maxWidth: 'calc(100vw - 10px)',
      }"
      :modal="true"
      :showClose="false"
      :dismissableMask="true"
      :title="__('Add') + ' ' + __('Service call')"
    >
      <local-add-service-call
        :serviceCall="serviceCall"
        :fastAdd="true"
        :close="
          () => {
            showModal = false;
          }
        "
        @serviceCallChanged="serviceCallChanged"
      ></local-add-service-call>
    </i-override-dialog>

    <p-get-image v-if="getImage" @getImage="getPictureLocal"></p-get-image>
  </div>
</template>

<script>
import LocalImage from "./image";
import PGetImage from "@/components/partials/p-get-image";
import { __ } from "@/plugins/i18n/";
import { callProc, apiParam, apiPType } from "@/services/APointAPI";
import { getPicture } from "@/services/UploadFilesService";
import { errorReceived } from "@/services/apointUtil";
import { mapState } from "vuex";
import LocalAddServiceCall from "../add-service-call";
import PTransitionExpand from "@/components/partials/p-transition-expand";
import { UploadServiceCallImageUrl } from "@/services/cloudflareUploaderService";
export default {
  components: {
    LocalImage,
    PGetImage,
    LocalAddServiceCall,
    PTransitionExpand,
  },
  props: {
    item: Object,
    chapterName: String,
    BID: Number,
  },
  emits: ["refreshServiceCall", "showResultPanel"],
  data() {
    return {
      itemLocal: null,
      showResultPanel: false,
      getImage: false,
      newImage: null,
      newImageData: null,
      newRemarks: "",
      showModal: false,
      serviceCall: {},
      newImageID: 0,
    };
  },
  mounted() {
    this.itemLocal = this.item;
    this.newRemarks = this.itemLocal.remarks;
  },
  methods: {
    changeStatus(status) {
      this.$emit("showResultPanel", this.itemLocal);
      if (status != this.item.checkResult) {
        this.itemLocal.checkResult = status;
        this.changeStatusInDB();
      }
    },
    changeStatusInDB() {
      let procParams = [
        apiParam("userID", this.userNum, apiPType.Int),
        apiParam(
          "TemplateItemID",
          this.item.mtcCheckListTemplateItemID,
          apiPType.NVarChar
        ),
        apiParam("PId", this.item.PID, apiPType.NVarChar),
        apiParam("result", this.item.checkResult, apiPType.NVarChar),
        apiParam("remarks", this.itemLocal.remarks, apiPType.NVarChar),
      ];
      callProc("WorkerApp_SetCheckListResult", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.itemLocal.checkResult = result.Table[0].checkResult;
          this.newRemarks = result.Table[0].remarks;
        })
        .catch(() => {
          errorReceived("TennatApp_CreateNewFile");
        });
    },
    addImage() {
      this.getImage = false;
      this.newImage = null;
      this.newImageID = 0;
      setTimeout(() => {
        this.getImage = true;
      }, 0);
    },
    getPictureLocal(sourceType) {
      getPicture(sourceType, (obj) => {
        this.getImage = false;
        this.newImage = obj;
        this.saveImage();
      });
    },
    saveImage() {
      this.$store.dispatch("doLoading", true);
      let procParams = [
        apiParam("PID", this.item.PID, apiPType.Int),
        apiParam("FileEXT", "JPEG", apiPType.NVarChar),
        apiParam("Subject", null, apiPType.NVarChar),
        apiParam(
          "mtcCheckListItemID",
          this.item.mtcCheckListTemplateItemID,
          apiPType.NVarChar
        ),
        apiParam("createBy", this.userNum, apiPType.Int),
      ];
      callProc("TennatApp_CreateNewFile", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.newImageData = result.Table[0];
          this.newImageData.PathImg = this.newImageData.PathImgEnc;
          this.newImageID = result.Table[0].ImgID;
          this.upload(this.newImage, this.newImageID, this.item.PID + ".jpeg");
        })
        .catch(() => {
          errorReceived("TennatApp_CreateNewFile");
        });
    },
    upload(file, FileId, srcFileName) {
      UploadServiceCallImageUrl(FileId, file, srcFileName)
        .then((response) => {
          this.$store.dispatch("doLoading", false);
          if (response === true) this.getImagesOfItem();
          // this.itemLocal.Images.push(this.newImageData);
        })
        .catch((e) => {
          errorReceived("שגיאה", e, __("There was an error saving the image"));
          this.uploadProgress = 0;
        });
    },
    addServiceCall() {
      this.showModal = true;
      this.serviceCall = {
        Subject: `${this.chapterName} - ${this.itemLocal.mtcItemName} - לא תקין`,
        WorkerNum: this.userNum,
        Desc: this.itemLocal.remarks,
        DueDate: new Date().setDate(new Date().getDate() + 1),
        BID: this.BID,
      };
    },
    serviceCallChanged(serviceCall) {
      // console.log(serviceCall);
      this.showModal = false;
      this.$emit("refreshServiceCall", serviceCall);
    },
    checkRemarkChanged() {
      if (this.newRemarks !== this.itemLocal.remarks) this.changeStatusInDB();
    },
    getImagesOfItem() {
      let procParams = [
        apiParam("PID", this.item.PID, apiPType.Int),
        apiParam(
          "mtcCheckListItemID",
          this.item.mtcCheckListTemplateItemID,
          apiPType.Int
        ),
      ];
      callProc("WorkerApp_CheckListItemImages", procParams)
        .then((result) => {
          result = JSON.parse(result);
          this.itemLocal.Images = result.Table;
        })
        .catch(() => {
          errorReceived("TennatApp_CreateNewFile");
        });
    },
  },
  computed: {
    ...mapState({
      userNum: (state) => state.api.workerID,
    }),
  },
};
</script>

<style scoped>
.p-inputtextarea {
  width: 100%;
}

.status {
  color: var(--color-accent);
  display: flex;
  align-items: center;
  gap: 5px;
}

.status .icon {
  font-weight: bold;
  font-size: 0.7rem;
}

.active {
  color: var(--color-success);
}

.images {
  display: grid;
  justify-content: space-between;
  grid-template-columns: 30% 30% 30%;
  gap: 15px;
}
</style>
